<template>
  <div>      
    <div id="busqueda-container" >      
        <input class="display-4 text-center" type="text" v-model="query_patente" placeholder="PATENTE"  @input="buscarAuto" maxlength="6" minlength="6" size="8" @keyup="mayus" >
    </div> 
</div> 
</template>

<script>

export default {
    name:'Busqueda',
    components:{
       
  
    },
    data(){
        return{
            query_patente:'',
            miauto:{},
        }
    },
    computed:{
        traerdataautos(){
            return this.$store.getters.enviardataautos;
        }
    },
    methods:{
        borrar(){
            this.query_patente=''
        },
        mayus() {            
            this.query_patente = this.query_patente.toUpperCase();
        },
        buscarAuto(){
            if(this.query_patente.length===6){
                this.miauto = this.$store.getters.enviardataautos.filter(datos => {
                    return datos.patente.includes(this.query_patente.toUpperCase())
                });                
                if(!this.miauto.length){
                    console.log("Registrar el auto nuevo")
                    //$('#CarAddModal').modal('show')
                    
                    this.$router.push(`/caradd/${this.query_patente}`);
                    
                    console.log("Mostrar datos y registrar parkeado");
                    
                }else{                    
                    console.log("Mostrar datos y registrar parkeado")
                    this.$router.push(`/carparking/${this.query_patente}`)
                    this.query_patente='';
                                      
                }
            }
        }
    }
}
</script>

<style>
#busqueda-container{
    margin-left: auto;
    margin-right: auto;
    width: 300px;
}

</style>